import { render, staticRenderFns } from "./JobProductManagerIcon.vue?vue&type=template&id=5c523ae0&"
import script from "./JobProductManagerIcon.vue?vue&type=script&lang=js&"
export * from "./JobProductManagerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports